<template>
  <v-carousel :show-arrows="false" height="170">
    <v-carousel-item v-for="(item, i) in items" :key="i" :src="item.src"></v-carousel-item>
  </v-carousel>
</template>
<script>
export default {
  data() {
    return {
      items: [
        {
          src: require('@/assets/images/common/carousel_banner03.jpg'),
        },
        // {
        //   src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg',
        // },
        // {
        //   src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg',
        // },
        // {
        //   src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg',
        // },
      ],
    }
  },
};
</script>
<style lang="scss">
div.v-carousel {
  width: 90vw;
  margin: 0 auto;
  overflow: initial;
  margin-bottom: 30px;

  .v-window__container {
    overflow: hidden;
    border-radius: 32px;
  }

  .v-carousel__controls {
    bottom: -50px;
    background: transparent;
    display: none;

    .v-btn.v-btn--icon {
      background-color: #C8C8C8;
      width: 10px;
      height: 10px;
      margin: 0 5px;
      transition: all 0.4s;

      &.v-item--active {
        // color: $mid-green;
        width: 26px;

        .v-icon {
          width: 26px;
          background-color: $mid-green;
          border-radius: 15px;
        }
      }

      &::before {
        display: none;
      }

      .v-icon {
        width: 10px;
        height: 10px;
        opacity: 1;
        transition: all 0.4s;

        &::before {
          display: none;
        }
      }
    }
  }
}</style>